/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/9
 */

import config from 'config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    qrcode: {
        url: `${authApi}/api/wework/auth/qrcode`,
        type: 'GET',
    },
    authSuite: {
        url: `${authApi}/api/wework/auth/suite/{suite_id}/qrcode`,
        type: 'GET',
    },
    accessToken: {
        url: `${authApi}/api/wework/auth/access_token`,
        type: 'GET',
    },
    deleteToken: {
        url: `${authApi}/api/auth/token`,
        type: 'DELETE',
    },
    init: {
        url: `${authApi}/api/auth/init`,
        type: 'GET',
    },
    agentConfig: {
        url: `${authApi}/api/wework/provider/jsapi/agent_config`,
        type: 'GET',
    },
    companyPermissions: {
        url: `${authApi}/api/company_permissions/mine`,
        type: 'GET',
    },
    weworkWorkbenchAuth: {
        url: `${authApi}/api/wework/auth/suite/access_token`,
        type: 'GET',
    },
    setGuide: {
        url: `${authApi}/api/guide`,
        type: 'POST',
    },
    getComponyList: {
        url: `${authApi}/api/companies/list`,
        type: 'GET',
    },
}
